
 <div class="modal-header">
    <h4 class="modal-title" id="mondalAddCampaignTitle">Enviar nuevo formulario para proveedor</h4>    
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<div class="modal-body">
    <h5><strong>Material - {{ nombre }}</strong></h5>    
    <h5 *ngIf="alias != '' ">Alias - {{alias}}</h5>    
    <div class="alert alert-info d-flex align-items-center" *ngIf="cargandoArte">
        <mat-spinner diameter="20" class="me-2"></mat-spinner>
        Preparando el arte para el proveedor...
    </div>
    <div class="alert alert-warning" *ngIf="!cargandoArte && !arteDisponible">
        <mat-icon class="align-middle me-1">warning_amber</mat-icon>
        {{ mensajeArteNoDisponible }}
    </div>
    <form [formGroup]="form">
       <!-- <ngx-file-drag-drop class="ngx-file_f" emptyPlaceholder="Arrastre o seleccione archivo" formControlName="blob" [formControl]="fileControl" (valueChanged)="onValueChange($event)">
        </ngx-file-drag-drop>-->
        <div class="row">            
            <div class="col-md-12">
                <mat-form-field class="w-100 mt-2" appearance="outline" >
                    <mat-label>Selecciona proveedor</mat-label>
                    <mat-select formControlName="id_provider" (selectionChange)="loadproviderInfo($event)" required>
                        <mat-option *ngFor="let p of providers"[value]="p.id">{{ p.nombre }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="members.length > 0" class="col-md-12">
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Miembros a notificar</mat-label>
                    <mat-select formControlName="membersSelected" multiple (openedChange)="onSelectOpened()">
                        <div class="p-2" (click)="$event.stopPropagation()">
                           <!-- <button mat-stroked-button class="w-100 mb-2" (click)="toggleSelectAllMembers()">
                                Seleccionar/Quitar todos
                            </button>-->
                            
                            <div class="search-option">
                              <div class="search-input-container mat-form-field-outlined">
                               <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>                             
                                <input #searchInput matInput [(ngModel)]="searchTerm" (ngModelChange)="filterMembers()"
                                    [ngModelOptions]="{standalone: true}" autocomplete="off">
                                <mat-icon matSuffix (click)="clearSearch()" *ngIf="searchTerm">close</mat-icon>
                               </div>
                            </div>
                             <button  mat-flat-button (click)="toggleSelectAllMembers()"><mat-icon>library_add</mat-icon>Seleccionar/Quitar todos los miembros</button>
                        </div>
                        <mat-option *ngFor="let member of filteredMembers" [value]="member.id">
                            {{ member.nombre }} - {{ member.email }}
                        </mat-option>
                    </mat-select>
                    <mat-hint>Seleccionados: {{ form.get('membersSelected')?.value?.length || 0 }} de {{ members.length }}</mat-hint>
                </mat-form-field>
            </div>
            <div *ngIf="members.length === 0 && providerSelected" class="col-md-12">
                <p class="text-muted">No hay miembros registrados para este proveedor.</p>
            </div>
           
            <div class="col-md-12 mb-2">
                <mat-checkbox [(ngModel)]="showMontoInput" (change)="onMontoConfigChange()" [ngModelOptions]="{standalone: true}">
                    Añadir monto configurado
                </mat-checkbox>
            </div>

            <div class="col-md-12" *ngIf="showMontoInput">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Monto configurado -  est. ${{ total }}</mat-label>
                    <input type="number" formControlName="monto" matInput placeholder="0.00">
                    <mat-error *ngIf="form.get('monto')?.hasError('required')">
                        El monto es requerido.
                    </mat-error>
                    <mat-error *ngIf="form.get('monto')?.hasError('maxAmountExceeded')">
                        El monto no puede exceder el restante de ${{ form.get('monto')?.getError('maxAmountExceeded').max | number:'1.2-2' }}.
                    </mat-error>
                    <mat-error *ngIf="form.get('monto')?.hasError('min')">
                        El monto no puede ser negativo.
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-md-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Mensaje para proveedor</mat-label>
                    <textarea formControlName="provider_msg" matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                        cdkAutosizeMaxRows="5" rows="3"></textarea>
                </mat-form-field>
            </div>
            <!--<div *ngIf="members.length != 0" class="col-md-12  d-inline-block" style="overflow: auto; max-height: 200px;">
                <mat-list >
                    <h5>Miembros proveedor:</h5>
                    <mat-list-item *ngFor="let member of members"><span style="font-size: 14px;">{{ member.nombre }} - {{ member.email }}</span></mat-list-item>
                </mat-list>
            </div>-->
        </div>        
    </form>
</div>
<div class="modal-footer">
    <button mat-flat-button mat-dialog-close>Cerrar <mat-icon>close</mat-icon></button>
    <button mat-flat-button class="bg-success text-white" [disabled]="cargandoArte || !arteDisponible || !form.valid" (click)="saveFile()">Enviar <mat-icon>save</mat-icon></button>
</div>
